// extracted by mini-css-extract-plugin
export default {"container":"bod_1JOdj","inherit":"bod_inh_2EBdE"};